document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(() => {
  const toggles = document.querySelectorAll('[data-bek-menu-toggle]');
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const targetId = toggle.getAttribute('aria-controls');
      const target = document.getElementById(targetId);
      if (!target) return;
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      target.hidden = open;
      document.body.classList.toggle('bek-menu-open', !open);
    });
  });
})();

// M11.13.1.4 – Show mobile landing CTA only after the hero has left the viewport.
(() => {
  const hero = document.querySelector('.m113-hero');
  const cta = document.querySelector('.m113-mobile-cta');
  if (!hero || !cta || !window.matchMedia('(max-width: 760px)').matches) return;
  const update = () => {
    const rect = hero.getBoundingClientRect();
    cta.classList.toggle('is-visible', rect.bottom <= 90);
  };
  update();
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
})();
